export default {"src":"/_next/static/media/download-wallet-app-qrcode.b3360183.svg","height":1007,"width":1007};